import React from 'react';
import { Search, EyeOpen, EyeClose } from '../../assets/icons/icons';
import { InputElement, InputContainer, InputIcon, TextIcon } from './styles';

export default ({
  HandleFocus = () => { },
  HandleIcon = () => { },
  animateWidth = '100%',
  dynamicSearch,
  autoComplete = 'off',
  placeholder,
  inputStyle,
  responsive,
  maxLength = 40,
  idKey,
  insetShadow = 'white',
  onChange,
  name,
  fontSize = 14,
  colorPlaceholder = '#acb1c0',
  disabled = false,
  bordeRadius = '8px',
  backgroundColor,
  color,
}: {
  animateWidth?: string;
  autoComplete?: string;
  placeholder?: string;
  inputStyle?: string;
  responsive?: string;
  maxLength?: number;
  dynamicSearch?: any;
  HandleFocus?: any;
  HandleIcon?: any;
  idKey?: string;
  insetShadow?: string;
  onChange?: any;
  name?: string;
  fontSize?: number;
  colorPlaceholder?: string;
  disabled?: boolean;
  bordeRadius?: string;
  backgroundColor?: string;
  color?: string;
}) => (
  <InputContainer
    bordeRadius={bordeRadius}
    icon={Boolean(dynamicSearch.icon?.lenght)}
    aWidth={animateWidth}
    inputStyle={inputStyle}
    inputStatus={dynamicSearch.status}
    onFocus={() => HandleFocus(idKey)}
    backgroundColor={backgroundColor}
  >
    <InputElement
      name={name}
      responsive={responsive}
      insetShadow={insetShadow}
      type={dynamicSearch?.type}
      onChange={onChange ? onChange : dynamicSearch.onChange}
      value={dynamicSearch?.value}
      placeholder={placeholder}
      maxLength={maxLength}
      inputStyle={inputStyle}
      autoComplete={autoComplete}
      fSize={fontSize}
      cPlaceholder={colorPlaceholder}
      readOnly={disabled}
      color={color}
    />
    {dynamicSearch?.icon === 'search' ? (
      <InputIcon iconExtraPadding={true}>
        <Search />
      </InputIcon>
    ) : dynamicSearch?.icon === 'eyeOpen' ? (
      <InputIcon iPadding={'14px'} clickable={true} onClick={() => HandleIcon(idKey)}>
        <EyeOpen />
      </InputIcon>
    ) : dynamicSearch?.icon === 'eyeClose' ? (
      <InputIcon iPadding={'14px'} clickable={true} onClick={() => HandleIcon(idKey)}>
        <EyeClose />
      </InputIcon>
    ) : dynamicSearch?.icon === 'text' ? (
      <InputIcon iPadding={'14px'} clickable={true} onClick={() => HandleIcon(idKey)}>
        <TextIcon>Apply</TextIcon>
      </InputIcon>
    ) : (
      <></>
    )}
  </InputContainer>
);
